import api from './api';

export interface AdminStats {
    appointmentsToday: number;
    monthlyRevenue: number;
    activeBarbers: number;
}

export const adminDashboardService = {
    getStats: async (): Promise<AdminStats> => {
        const response = await api.get<AdminStats>('/admin/dashboard/stats');
        return response.data;
    }
};
